import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import MainLayout from './layout/MainLayout';
import AuthLayout from './layout/AuthLayout';
import { UpdateProvider, UpdateNotification } from './components/ui/update';
import { AlertProvider } from './components/ui/alert';
import { NotFound, Forbidden, ServerError } from './page/error';

import Home from './page/Home';
import Login from './page/Login';
import Register from './page/Register';
import AdminLogin from './page/private/AdminLogin';
import Dashboard from './page/Dashboard';
import Events from './page/Events';
import Settings from './page/Settings';
import Admin from './page/private/AdminDashboard';
import AdminSettings from './page/private/AdminSettings';
import StatusManagement from './page/private/StatusManagement';
import EventManagement from './page/private/EventManagement';
import FriendsManagement from './page/private/FriendsManagement';
import AIChat from './page/AIChat';
import PrivateRoute from './components/redirect/PrivateRoute';
import AdminPrivateRoute from './components/redirect/AdminPrivateRoute';

import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SocketProvider } from './context/SocketContext';

function App() {
  return (
    <ThemeProvider>
      <AlertProvider>
        <SocketProvider>
          <AuthProvider>
            <AdminAuthProvider>
              <UpdateProvider>
                <UpdateNotification />
                <BrowserRouter>
                <Routes>
                  {/* Layout Auth (no sidebar / no topbar) */}
                  <Route element={<AuthLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    
                  </Route>

                  {/* Layout principale (sidebar + topbar) */}
                  <Route element={<MainLayout />}>
                    {/* Rotta pubblica (o protetta) */}
                    

                    {/* Rotte protette utente */}
                    <Route element={<PrivateRoute />}>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/ai-chat" element={<AIChat />} />
                      <Route path="/eventi" element={<Events />} />
                    </Route>

                    {/* Rotte protette admin */}
                    <Route element={<AdminPrivateRoute />}>
                      <Route path="/admin" element={<Admin />} />
                      <Route path="/admin/settings" element={<AdminSettings />} />
                      <Route path="/stato-becco" element={<StatusManagement />} />
                      <Route path="/gestione-eventi" element={<EventManagement />} />
                      <Route path="/gestione-amici" element={<FriendsManagement />} />
                    </Route>
                  </Route>
                  {/* Rotte per errori */}
                  <Route path="/403" element={<Forbidden />} />
                  <Route path="/500" element={<ServerError />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
            </UpdateProvider>
            </AdminAuthProvider>
          </AuthProvider>
        </SocketProvider>
      </AlertProvider>
    </ThemeProvider>
  );
}

export default App;